import { render, staticRenderFns } from "./RecognitionCardSkeleton.vue?vue&type=template&id=70806442"
import script from "./RecognitionCardSkeleton.vue?vue&type=script&lang=js"
export * from "./RecognitionCardSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports